module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/cinematic_stock-background-f91da0276d5a9e70ba1ed39702149732.jpg";